/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Field_Confirmed_By_PhoneInputs */

const en_cad_field_confirmed_by_phone = /** @type {(inputs: Cad_Field_Confirmed_By_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone number`)
};

const ja_cad_field_confirmed_by_phone = /** @type {(inputs: Cad_Field_Confirmed_By_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電話番号`)
};

const fr_cad_field_confirmed_by_phone = /** @type {(inputs: Cad_Field_Confirmed_By_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de téléphone`)
};

const de_cad_field_confirmed_by_phone = /** @type {(inputs: Cad_Field_Confirmed_By_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonnummer`)
};

/**
* | output |
* | --- |
* | "Phone number" |
*
* @param {Cad_Field_Confirmed_By_PhoneInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_field_confirmed_by_phone = /** @type {((inputs?: Cad_Field_Confirmed_By_PhoneInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Field_Confirmed_By_PhoneInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_field_confirmed_by_phone(inputs)
	if (locale === "ja") return ja_cad_field_confirmed_by_phone(inputs)
	if (locale === "fr") return fr_cad_field_confirmed_by_phone(inputs)
	return de_cad_field_confirmed_by_phone(inputs)
});